import React, { FC } from 'react';
import styles from './footerForStages.module.scss';
import { ReactComponent as Check } from 'assets/icons/ticket_closed.svg';
import AlertAnimation from '../AlertAnimation';
import clsx from 'clsx';

interface FooterForStagesProps {
  footerItems: {
    key: number;
    icon: React.JSX.Element;
    title: string;
    isActive: boolean;
  }[];
}

const FooterForStages: FC<FooterForStagesProps> = props => {
  const { footerItems } = props;
  const isActiveItem = footerItems.find(item => item.isActive);
  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerCardContainer}>
        {footerItems?.map(item => {
          const inCompletedItem = isActiveItem && item.key > isActiveItem?.key;
          const completedItem = isActiveItem && item.key < isActiveItem?.key;
          return (
            <div
              key={item.key}
              className={clsx(
                // default class selector
                styles.itemContainer,
                // for active Item
                item.isActive && styles.activeItem,
                // for the items which are right side from active item
                inCompletedItem && styles.inCompletedItem,
                // for the items which are left side from active item
                completedItem && styles.completedItem
              )}>
              <div className={styles.itemDetails}>
                <span>
                  {inCompletedItem ? (
                    <div>{`${item.key}.`}</div>
                  ) : completedItem ? (
                    <div className={styles.completedIcon}>
                      <Check />
                    </div>
                  ) : (
                    item.icon
                  )}
                </span>
                <span>{item.title}</span>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.alertContainer}>
        {footerItems?.map(item =>
          item?.isActive ? (
            <div key={item.key} className={styles.alertItem}>
              <AlertAnimation />
            </div>
          ) : (
            // for proper alignment using div element
            <div key={item.key} />
          )
        )}
      </div>
    </div>
  );
};

export default FooterForStages;
